import React from 'react';
import { getIconPath } from '@tcp/core/src/utils/utils';
import PropTypes from 'prop-types';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import LineSeperator from '../../../atoms/LineSeperator';
import {
  LoginOptionContainer,
  LoginIcon,
  LoginTextContent,
  LoginArrow,
  LoginHeading,
  LoginSubHeading,
  RightArrow,
} from '../styles/LoginOptions.styles';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
} from '../../../../../../../utils/labels/globalLogin.labels';
import { isMobileWeb } from '../../../../../../../utils';

const SMS = 'sms';
const EMAIL = 'email';
const PASSWORD = 'password';
const getHeading = (type, loginLabels = {}, fromPlccICLogin) => {
  if (type === SMS)
    return fromPlccICLogin && !isMobileWeb()
      ? `${loginLabels.lbl_login_sms_v2_heading} and buy now`
      : loginLabels.lbl_login_sms_v2_heading;
  if (type === EMAIL)
    return fromPlccICLogin && !isMobileWeb()
      ? `${loginLabels.lbl_login_email_v2_heading} and buy now`
      : loginLabels.lbl_login_email_v2_heading;
  if (type === PASSWORD)
    return fromPlccICLogin && !isMobileWeb()
      ? `${loginLabels.lbl_login_pass_v2_heading} and buy now`
      : loginLabels.lbl_login_pass_v2_heading;
  return '';
};
const getSubHeading = (type, loginLabels, maskedPhoneNumber, emailAddress) => {
  if (type === SMS)
    return (
      <>
        <p>
          {loginLabels.lbl_code_msg} {maskedPhoneNumber}
        </p>
        <p>{loginLabels.lbl_login_sms_v2_subheading_2}</p>
      </>
    );
  if (type === EMAIL) return `${loginLabels.lbl_login_email_v2_subheading} ${emailAddress || ''}`;
  return '';
};
const getIcon = (type) => {
  switch (type) {
    case SMS:
      return 'sms-survey';
    case EMAIL:
      return 'sign-up-for-email';
    case PASSWORD:
      return 'survey-lock';
    default:
      return '';
  }
};
const LoginOptions = (props) => {
  const { type, maskedPhoneNumber, submitForm, emailAddress, fromPlccICLogin } = props;
  const clickHandler = (e) => {
    submitForm(e, type);
  };
  const loginLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);
  return (
    <>
      <LoginOptionContainer onClick={clickHandler} noLink>
        <LoginIcon>
          <Image src={getIconPath(getIcon(type))} alt={`${type} icon`} />
        </LoginIcon>
        <LoginTextContent>
          <LoginHeading component="p" fontFamily="secondary" fontSize="fs14" fontWeight="extrabold">
            {getHeading(type, loginLabels, fromPlccICLogin)}
          </LoginHeading>
          <LoginSubHeading
            component="p"
            fontFamily="secondary"
            fontSize="fs12"
            fontWeight="semibold"
          >
            {getSubHeading(type, loginLabels, maskedPhoneNumber, emailAddress)}
          </LoginSubHeading>
        </LoginTextContent>
        <LoginArrow>
          <RightArrow />
        </LoginArrow>
      </LoginOptionContainer>
      <LineSeperator />
    </>
  );
};

LoginOptions.propTypes = {
  type: PropTypes.string.isRequired,
  maskedPhoneNumber: PropTypes.string,
  emailAddress: PropTypes.string,
  submitForm: PropTypes.func,
};
LoginOptions.defaultProps = {
  maskedPhoneNumber: '',
  emailAddress: '',
  submitForm: () => {},
};

export default LoginOptions;
